import * as React from 'react';

import type { PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';
import { HeroBlock } from 'stile-shared/src/components/2020/blocks/HeroBlock';
import { ResourceBlock } from 'stile-shared/src/components/2020/blocks/ResourceBlock';
import { TextBlock } from 'stile-shared/src/components/2020/blocks/TextBlock';
import { Card } from 'stile-shared/src/components/2020/common/Card';
import { H3, P } from 'stile-shared/src/components/2020/common/Primitives';
import { VideoModalLauncher } from 'stile-shared/src/components/2020/common/VideoModalLauncher';
import { Center } from 'stile-shared/src/components/2020/layout/Center';
import { Column } from 'stile-shared/src/components/2020/layout/Column';
import { theme } from 'stile-shared/src/styles/2020/theme';

import { getPageData } from 'utils/getPageData';

import { PageLayout } from 'templates/2020/PageLayout';

import { NextPageBlock } from 'components/blocks/NextPageBlock';

export { Head } from 'templates/2020/Head';

function CaseStudiesPage(props: PageProps) {
  const { hero } = getPageData(props.location.pathname);

  return (
    <PageLayout {...props}>
      <HeroBlock
        {...hero}
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/resources/case_studies_cover.png"
            alt=""
          ></StaticImage>
        }
      />

      <TextBlock>
        <P>
          We support tens of thousands of teachers and hundreds of thousands of students around the
          world. Hear directly from them on the impact Stile is having in their classrooms.
        </P>
      </TextBlock>

      <ResourceBlock title="Insights from Stile educators" colorVariant="beige">
        <Card
          space={theme.space.xxs}
          title="Case study: Stile X at Montmorency Secondary College"
          text="Campbell shares how Stile's comprehensive curriculum is improving student outcomes."
          url="https://stileapp.com/go/stile_x_montmorency_sc"
          image={
            <StaticImage
              src="../../../../stile-shared/assets/images/resources/tile_montmorency_case_study.png"
              alt=""
            />
          }
        />

        <Card
          space={theme.space.xxs}
          title="Case study: Stile X at Nerang State High School"
          text="Lara talks about how she’s preparing for the new Australian Curriculum with Stile."
          url="https://stileapp.com/go/stile_x_nerang_shs"
          image={
            <StaticImage
              src="../../../../stile-shared/assets/images/resources/tile_nerang_shs_case_study.png"
              alt=""
            />
          }
        />

        <Card
          space={theme.space.xxs}
          title="Case study: Stile X at Galen Catholic College"
          text="Samuel discusses three ways that Stile enhances science teaching and learning at his school."
          url="https://stileapp.com/go/stile_x_galen_catholic_college"
          image={
            <StaticImage
              src="../../../../stile-shared/assets/images/resources/tile_galen_case_study.png"
              alt=""
            />
          }
        />

        <Card
          space={theme.space.xxs}
          title="Case study: Stile X at Covenant College"
          text="Nathanael shares how his first semester with Stile X is going."
          url="https://stileapp.com/go/stile_x_covenant_college"
          image={
            <StaticImage
              src="../../../../stile-shared/assets/images/resources/tile_covenant_case_study.png"
              alt=""
            />
          }
        />

        <Card
          space={theme.space.xxs}
          title="Case study: Stile X at Collingwood College"
          text="Michelle discusses how Stile X helps build her students' skills for the future."
          url="https://stileapp.com/go/stile_x_collingwood_college"
          image={
            <StaticImage
              src="../../../../stile-shared/assets/images/resources/tile_collingwood_case_study.png"
              alt=""
            />
          }
        />
      </ResourceBlock>

      <TextBlock>
        <Center max={theme.space.measure}>
          <Column space={theme.space.section}>
            <Column space={theme.space.mToL}>
              <H3>
                Hear from Lachlan, Head of Science at Box Hill High School, on his experience with
                Stile
              </H3>
              <VideoModalLauncher
                text="Watch Stile in action (2 mins)"
                url="https://www.youtube.com/watch?v=jcLFR8p8nDw"
                coverImage={
                  <StaticImage
                    loading="eager"
                    src="../../../../stile-shared/assets/images/home/video_cover_au.jpg"
                    alt="A teacher is showing something on a tablet to three students. The students are leaning in to see and are enjoying themselves"
                  />
                }
              />
            </Column>
          </Column>
        </Center>
      </TextBlock>

      <NextPageBlock path="/resources/ict-professionals/" />

      <CtaBlock />
    </PageLayout>
  );
}

export default CaseStudiesPage;
